
import React, { createContext, useState, useContext } from 'react';

// A Context létrehozása
const LoadingContext = createContext();

// A Provider, amely körbeveszi a fő alkalmazást
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  // A loading állapot módosítása
  const toggleLoading = (state) => {
    setLoading(state);
  };

  return (
    <LoadingContext.Provider value={{ loading, toggleLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

// A context elérhetősége
export const useLoading = () => useContext(LoadingContext);
